import React, { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../context/LoginContext";
import AuthenticatedMedia from "../AuthenticatedMedia";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import logo from "../../Imagens/logoformari_vertical.jpeg";
import {
  FaBoxOpen,
  FaCalendarAlt,
  FaChartBar,
  FaChevronDown,
  FaChevronUp,
  FaCog,
  FaCloudUploadAlt,
  FaFolder,
  FaIdCard,
  FaImages,
  FaMoneyBillWave,
  FaPortrait,
  FaSchool,
  FaSignOutAlt,
  FaUser,
  FaUserGraduate,
  FaUsers,
} from "react-icons/fa";
import { getNavigationItems } from "../../auth/access";
import { USER_ROLES } from "../../auth/session";

const ICONS = {
  calendar: FaCalendarAlt,
  dashboard: FaChartBar,
  "face-analysis": FaPortrait,
  folder: FaFolder,
  "id-card": FaIdCard,
  images: FaImages,
  products: FaBoxOpen,
  sales: FaMoneyBillWave,
  school: FaSchool,
  settings: FaCog,
  student: FaUserGraduate,
  upload: FaCloudUploadAlt,
  users: FaUsers,
};

const NavigationIcon = ({ name, submenu = false }) => {
  const Icon = ICONS[name] || FaFolder;
  return (
    <Icon
      aria-hidden="true"
      className={`menu-icon${submenu ? " submenu-icon" : ""}`}
    />
  );
};

function MenuLateral() {
  const navigate = useNavigate();
  const location = useLocation();
  const { LoggedUser, signOut } = useContext(LoginContext);
  const navigationItems = getNavigationItems(LoggedUser?.role);
  const [openSection, setOpenSection] = useState(null);

  useEffect(() => {
    const activeSection = navigationItems.find((item) =>
      item.children?.some((child) => child.path === location.pathname),
    );

    setOpenSection(activeSection?.id || null);
  }, [location.pathname, navigationItems]);

  const handleLogout = async () => {
    await signOut();
    navigate("/", { replace: true });
  };

  return (
    <div className="menu-lateral">
      <div className="menu-logo">
        <img src={logo} alt="Formari" />
      </div>

      <div className="menu-perfil">
        <div className="menu-avatar-wrap">
          {LoggedUser?.referencePhotoMedia?.path ? (
            <AuthenticatedMedia
              path={LoggedUser.referencePhotoMedia.path}
              alt={`Foto de referência de ${LoggedUser?.name || "usuário"}`}
              className="menu-avatar"
              fallback={
                <span
                  className="menu-avatar menu-avatar-fallback"
                  role="img"
                  aria-label="Sem foto de referência"
                >
                  <FaUser aria-hidden="true" />
                </span>
              }
            />
          ) : (
            <span
              className="menu-avatar menu-avatar-fallback"
              role="img"
              aria-label="Sem foto de referência"
            >
              <FaUser aria-hidden="true" />
            </span>
          )}
        </div>
        <div className="menu-info">
          <strong>{LoggedUser?.name}</strong>
          <small>{LoggedUser?.email}</small>
          {LoggedUser?.role === USER_ROLES.ADMIN ? (
            <span className="menu-role-badge">ADMINISTRADOR</span>
          ) : null}
        </div>
      </div>

      <nav className="menu-nav" aria-label="Navegação principal">
        <div className="menu-nav-heading" aria-hidden="true">
          <span>Navegação</span>
          <span className="menu-nav-heading-line" />
        </div>

        {navigationItems.map((item) => {
          if (!item.children) {
            return (
              <NavLink
                key={item.id}
                to={item.path}
                end
                className={({ isActive }) =>
                  `menu-link${isActive ? " is-active" : ""}`
                }
              >
                <NavigationIcon name={item.icon} />
                <span className="menu-link-label">{item.label}</span>
              </NavLink>
            );
          }

          const isOpen = openSection === item.id;
          const hasActiveChild = item.children.some(
            (child) => child.path === location.pathname,
          );

          return (
            <div key={item.id} className="menu-section">
              <button
                type="button"
                className={`menu-link menu-collapse-button${
                  hasActiveChild ? " is-active" : ""
                }`}
                onClick={() => setOpenSection(isOpen ? null : item.id)}
                aria-expanded={isOpen}
                aria-controls={`menu-submenu-${item.id}`}
              >
                <NavigationIcon name={item.icon} />
                <span className="menu-link-label">{item.label}</span>
                {isOpen ? (
                  <FaChevronUp aria-hidden="true" className="menu-collapse-icon" />
                ) : (
                  <FaChevronDown aria-hidden="true" className="menu-collapse-icon" />
                )}
              </button>

              {isOpen ? (
                <div
                  id={`menu-submenu-${item.id}`}
                  className="menu-submenu"
                >
                  {item.children.map((child) => (
                    <NavLink
                      key={child.id}
                      to={child.path}
                      end
                      className={({ isActive }) =>
                        `menu-sublink${isActive ? " is-active" : ""}`
                      }
                    >
                      <NavigationIcon name={child.icon} submenu />
                      <span className="menu-link-label">{child.label}</span>
                    </NavLink>
                  ))}
                </div>
              ) : null}
            </div>
          );
        })}
      </nav>

      <div className="menu-footer">
        <div className="menu-footer-divider" aria-hidden="true" />
        <button
          type="button"
          className="menu-link menu-logout"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="menu-icon" aria-hidden="true" />
          <span className="menu-link-label">Sair</span>
        </button>
      </div>
    </div>
  );
}

export default MenuLateral;
